module.exports = __webpack_public_path__ + "img/import-export.8c9b8737.svg";